// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-2dBty";
var _4 = "rightSide-3iWu7";
var _5 = "passengerInfo-3HbUD";
var _6 = "passengerInfo__item-3EFVr";
var _7 = "passengerInfo__field-1cyhJ";
var _8 = "loyalty__link-3q0HP";
var _9 = "passenger__icon-2sk8Q";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "rightSide", _5 as "passengerInfo", _6 as "passengerInfo__item", _7 as "passengerInfo__field", _8 as "loyalty__link", _9 as "passenger__icon" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "rightSide": _4, "passengerInfo": _5, "passengerInfo__item": _6, "passengerInfo__field": _7, "loyalty__link": _8, "passenger__icon": _9 }
